module.exports = __webpack_public_path__ + "static/media/essential-questions.1dcf6578.md";